import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import styles from './PDCSelector.module.css';
import { CancelButton, ApplyButton, DBDropDown, DBDropDownPDC } from '_components';
import { Modal } from 'react-bootstrap'


class PatientCareCenterNoteSubjectivePDCSelector extends React.Component {


    constructor(props) {
        super(props);
        this.state = {
            warningVisible: false,
            warningType: undefined,
            column: undefined,
            value: undefined,
            newPdc: undefined,
            deleteReason: undefined
        };
    }

    computePdc(stand, walk, lift) {
        let key = Object.keys(this.props.pdcLookup)
            .find(x =>
                this.props.pdcLookup[x].PXSTANDFREQ === stand
                && this.props.pdcLookup[x].PXWALKFREQ === walk
                && (this.props.pdcLookup[x].PXLIFTWEIGHT === lift || this.props.pdcLookup[x].PXLIFTWEIGHT === null)
            );

        return key ? this.props.pdcLookup[key].PXPDC : undefined;
    }

    handleJobReqChange(event) {
        let jrStand = this.props.jobReqStand;
        let jrWalk = this.props.jobReqWalk;
        let jrLift = this.props.jobReqLift;
        let tempColumn = undefined;
        let tempValue = undefined;

        switch (event.target.name) {
            case this.props.prefix + 'SUBWCJOBREQSTAND':
                jrStand = parseInt(event.target.value);
                tempColumn = this.props.prefix + 'SUBWCJOBREQSTAND';
                tempValue = jrStand;
                break;
            case this.props.prefix + 'SUBWCJOBREQWALK':
                jrWalk = parseInt(event.target.value);
                tempColumn = this.props.prefix + 'SUBWCJOBREQWALK';
                tempValue = jrWalk;
                break;
            case this.props.prefix + 'SUBWCJOBREQLIFT':
                jrLift = parseInt(event.target.value);
                tempColumn = this.props.prefix + 'SUBWCJOBREQLIFT';
                tempValue = jrLift;
                break;
            default:
                break;
        }

        let pdc = this.computePdc(jrStand, jrWalk, jrLift);

        if (this.props.jobReqPdc !== undefined && pdc !== undefined && this.props.jobReqPdc.WPNO !== pdc) {
            if (this.props.hasGoals) {
                this.setState({
                    warningVisible: true,
                    warningType: 'set',
                    column: tempColumn,
                    value: tempValue,
                    newPdc: pdc
                });
                event.stopPropagation();
            } else {
                this.props.updateIntField(this.props.noteId, this.props.table, this.props.prefix + 'NO', this.props.pk, this.props.prefix + 'SUBWCJOBREQPDC', pdc)
            }
        } else if (this.props.jobReqPdc !== undefined && pdc === undefined) {
            if (this.props.hasGoals) {
                this.setState({
                    warningVisible: true,
                    warningType: 'clear',
                    column: tempColumn,
                    newPdc: pdc
                });
                event.stopPropagation();
            } else {
                this.props.clearField(this.props.noteId, this.props.table, this.props.prefix + 'NO', this.props.pk, this.props.prefix + 'SUBWCJOBREQPDC')
            }
        } else if (this.props.jobReqPdc === undefined && pdc !== undefined) {
            this.props.updateIntField(this.props.noteId, this.props.table, this.props.prefix + 'NO', this.props.pk, this.props.prefix + 'SUBWCJOBREQPDC', pdc)
        }
    }

    handleCurrentChange(event) {
        let curStand = this.props.currentStand;
        let curWalk = this.props.currentWalk;
        let curLift = this.props.currentLift;

        switch (event.target.name) {
            case this.props.prefix + 'SUBWCCURRENTSTAND':
                curStand = parseInt(event.target.value);
                break;
            case this.props.prefix + 'SUBWCCURRENTWALK':
                curWalk = parseInt(event.target.value);
                break;
            case this.props.prefix + 'SUBWCCURRENTLIFT':
                curLift = parseInt(event.target.value);
                break;
            default:
                break;
        }

        let pdc = this.computePdc(curStand, curWalk, curLift);

        if (this.props.currentPdc !== undefined && pdc !== undefined && this.props.currentPdc.WPNO !== pdc) {
            this.props.updateIntField(this.props.noteId, this.props.table, this.props.prefix + 'NO', this.props.pk, this.props.prefix + 'SUBWCCURRENTPDC', pdc)
        } else if (this.props.currentPdc !== undefined && pdc === undefined) {
            this.props.clearField(this.props.noteId, this.props.table, this.props.prefix + 'NO', this.props.pk, this.props.prefix + 'SUBWCCURRENTPDC')
        } else if (this.props.currentPdc === undefined && pdc !== undefined) {
            this.props.updateIntField(this.props.noteId, this.props.table, this.props.prefix + 'NO', this.props.pk, this.props.prefix + 'SUBWCCURRENTPDC', pdc)
        }
    }

    confirmPdcChange() {
        if (this.state.warningType === 'set') {
            this.props.updateIntField(this.props.noteId, this.props.table, this.props.prefix + 'NO', this.props.pk, this.state.column, this.state.value);
            this.props.updateIntField(this.props.noteId, this.props.table, this.props.prefix + 'NO', this.props.pk, this.props.prefix + 'SUBWCJOBREQPDC', this.state.newPdc);
        } else if (this.state.warningType === 'clear') {
            this.props.clearField(this.props.noteId, this.props.table, this.props.prefix + 'NO', this.props.pk, this.state.column);
            this.props.clearField(this.props.noteId, this.props.table, this.props.prefix + 'NO', this.props.pk, this.props.prefix + 'SUBWCJOBREQPDC');
        }
        this.props.clearGoals(this.props.noteId, 'PDC Level Changed: ' + this.state.deleteReason);
        this.setState({
            warningVisible: false,
            warningType: undefined,
            column: undefined,
            value: undefined,
            newPdc: undefined,
            deleteReason: undefined
        });
    }

    cancel() {
        this.setState({
            warningVisible: false,
            warningType: undefined,
            column: undefined,
            value: undefined,
            newPdc: undefined,
            deleteReason: undefined
        });
    }

    handleDeleteReasonChange(event) {
        this.setState({
            deleteReason: event.target.value
        });
    }

    render() {
        return (
            <div>
                {this.state.warningVisible &&
                    <Modal show={true} backdrop='static' keyboard={false} dialogClassName={styles.dialog}>
                        <div className={styles.title}>Work Comp PDC Warning</div>
                        <div className={styles.description}>
                            WARNING - You are about to change the PDC level for this
                            patient.  All of the current goals will be DELETED and
                            new goals will be required.  Provide a reason for this
                            change in the space below:
                        </div>
                        <div className={styles.reason_wrapper}>
                            <textarea name="pdcChangeReason" type="text" className={styles.reason} rows="6" value={this.state.deleteReason} onChange={(event) => this.handleDeleteReasonChange(event)} />
                        </div>
                        <div className={styles.buttons}>
                            <span className={styles.button_wrapper}>
                                <ApplyButton size='small' title='Confirm PDC Change' onClick={() => this.confirmPdcChange()} />
                            </span>
                            <span className={styles.button_wrapper}>
                                <CancelButton size='small' title='Cancel' onClick={() => this.cancel()} />
                            </span>
                        </div>
                    </Modal>

                }

                <PatientCareCenterNoteSection id='ass_current_pdc' name='Current PDC Analysis' level={2} allowCollapse={false} >
                    <div className={styles.row}>
                        <label className={this.props.noteType === 4 ? styles.wide_col : styles.wide_col_req}>How much time is the patient currently able to <b>stand</b>:</label>
                        <span className={styles.leftover_col}>
                            <DBDropDownPDC
                                className={styles.drop_down}
                                noteId={this.props.noteId}
                                entity={this.props.table}
                                entityKeyColumn={this.props.prefix + 'NO'}
                                entityKeyValue={this.props.pk}
                                field={this.props.prefix + 'SUBWCCURRENTSTAND'}
                                isCurrent={true}
                                onChange={event => this.handleCurrentChange(event)}
                            />
                        </span>
                    </div>
                    <div className={styles.row}>
                        <label className={this.props.noteType === 4 ? styles.wide_col : styles.wide_col_req}>How much time is the patient currently able to <b>walk</b>:</label>
                        <span className={styles.leftover_col}>
                            <DBDropDownPDC
                                className={styles.drop_down}
                                noteId={this.props.noteId}
                                entity={this.props.table}
                                entityKeyColumn={this.props.prefix + 'NO'}
                                entityKeyValue={this.props.pk}
                                field={this.props.prefix + 'SUBWCCURRENTWALK'}
                                isCurrent={true}
                                onChange={event => this.handleCurrentChange(event)}
                            />
                        </span>
                    </div>
                    <div className={styles.row}>
                        <label className={this.props.noteType === 4 ? styles.wide_col : styles.wide_col_req}>How much weight is the patient currently able to <b>lift</b>:</label>
                        <span className={styles.leftover_col}>
                            <DBDropDown
                                className={styles.drop_down}
                                noteId={this.props.noteId}
                                entity={this.props.table}
                                entityKeyColumn={this.props.prefix + 'NO'}
                                entityKeyValue={this.props.pk}
                                field={this.props.prefix + 'SUBWCCURRENTLIFT'}
                                masterEntity='PTMASTERWCPDCWEIGHT'
                                masterEntityKeyColumn='WWNO'
                                masterEntitySort='WWORDER'
                                masterEntityDisplay='WWNAME'
                                onChange={event => this.handleCurrentChange(event)}
                            />
                        </span>
                    </div>
                    <div className={styles.row}>
                        <label className={styles.wide_col}>Current PDC:</label>
                        <span className={styles.leftover_col}>
                            {this.props.currentPdc ? this.props.currentPdc.WPNAME : ''}
                        </span>
                    </div>
                </PatientCareCenterNoteSection>


            </div>
        );
    }

}


function mapDispatchToProps(dispatch) {
    return {
        updateIntField: bindActionCreators(noteActions.updateIntField, dispatch),
        clearField: bindActionCreators(noteActions.clearField, dispatch),
        clearGoals: bindActionCreators(noteActions.clearGoals, dispatch)
    };
}


function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);

    let hasGoals = Object.keys(state.entities.notes.PTGOALS)
        .filter(key => {
            return ((noteType === 1 && state.entities.notes.PTGOALS[key].GOEVNO === pk) ||
                (noteType !== 1 && state.entities.notes.PTGOALS[key].GONTNO === pk)) &&
                state.entities.notes.PTGOALS[key].GODELETED !== true
        })
        .map(key => state.entities.notes.PTGOALS[key]).length ? true : false;

    let jobReqStand = noteType === 1 ?
        state.entities.notes.PTEVAL[pk].EVSUBWCJOBREQSTAND :
        state.entities.notes.PTNOTE[pk].NTSUBWCJOBREQSTAND;
    let jobReqWalk = noteType === 1 ?
        state.entities.notes.PTEVAL[pk].EVSUBWCJOBREQWALK :
        state.entities.notes.PTNOTE[pk].NTSUBWCJOBREQWALK;
    let jobReqLift = noteType === 1 ?
        state.entities.notes.PTEVAL[pk].EVSUBWCJOBREQLIFT :
        state.entities.notes.PTNOTE[pk].NTSUBWCJOBREQLIFT;
    let currentStand = noteType === 1 ?
        state.entities.notes.PTEVAL[pk].EVSUBWCCURRENTSTAND :
        state.entities.notes.PTNOTE[pk].NTSUBWCCURRENTSTAND;
    let currentWalk = noteType === 1 ?
        state.entities.notes.PTEVAL[pk].EVSUBWCCURRENTWALK :
        state.entities.notes.PTNOTE[pk].NTSUBWCCURRENTWALK;
    let currentLift = noteType === 1 ?
        state.entities.notes.PTEVAL[pk].EVSUBWCCURRENTLIFT :
        state.entities.notes.PTNOTE[pk].NTSUBWCCURRENTLIFT;

    let jrPDC = noteType === 1 ?
        state.entities.notes.PTEVAL[pk].EVSUBWCJOBREQPDC :
        state.entities.notes.PTNOTE[pk].NTSUBWCJOBREQPDC;
    let curPDC = noteType === 1 ?
        state.entities.notes.PTEVAL[pk].EVSUBWCCURRENTPDC :
        state.entities.notes.PTNOTE[pk].NTSUBWCCURRENTPDC;

    return {
        noteId,
        noteType,
        pk,
        jobReqStand,
        jobReqWalk,
        jobReqLift,
        currentStand,
        currentWalk,
        currentLift,
        pdcLookup: state.entities.masterData.PTMASTERWCPDCXREF,
        jobReqPdc: state.entities.masterData.PTMASTERWCPDC[jrPDC],
        currentPdc: state.entities.masterData.PTMASTERWCPDC[curPDC],
        hasGoals,
        prefix: noteType === 1 ? "EV" : "NT",
        table: noteType === 1 ? "PTEVAL" : "PTNOTE"
    };
}

const connectedPatientCareCenterNoteSubjectivePDCSelector = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteSubjectivePDCSelector);
export { connectedPatientCareCenterNoteSubjectivePDCSelector as PatientCareCenterNoteSubjectivePDCSelector };

